module.exports = __webpack_public_path__ + "img/fd_ic_wq.ca71418e.svg";